import { useMemo } from 'react'

/**
 * useLineDash is a low-level hook that memoizes the dash array of a line.
 * @param geometry A `geometry`, either a string or an array of numbers
 * @returns The memoized `H.geo.LineString` that represents the geometry.
 */
export const useLineDash = (dashArray?: number[]) => {
  const lineDash = useMemo(() => dashArray, [JSON.stringify(dashArray)])

  return lineDash
}
